import { useState, useRef, useMemo } from 'react';

export const useSidebar = (textType, collapsed = false, initialWidth = 400) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(collapsed);
  const [sidebarWidth, setSidebarWidth] = useState(initialWidth);
  const sidebarRef = useRef(null);

  const handleOpenSidebarAndScrollTop = () => {
    setSidebarCollapsed(false);
    sidebarRef.current.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleScrollBottom = () => {
    sidebarRef.current.scrollTo({
      top: sidebarRef.current.scrollHeight,
      behavior: 'smooth',
    });
  };

  const showSidebar = useMemo(() => {
    return (
      textType === 'NON_TRANSLATED' ||
      textType === 'COMBINED' ||
      textType === 'EDITORIAL'
    );
  }, [textType]);

  return {
    sidebarCollapsed,
    setSidebarCollapsed,
    sidebarWidth,
    setSidebarWidth,
    sidebarRef,
    handleOpenSidebarAndScrollTop,
    showSidebar,
    handleScrollBottom,
  };
};
